<!--
    Work Screen of the Memory Game
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>

	<div class='container'>
		<div id="content" class='content'>
			
			<div class="bar darkText largeText">
				<div class="gridLabel bg-timeline">{{ model.getDictionary('nav_game') }}</div>

				<div class="gridTriple bg-timeline-light">{{ model.getDictionary('game_memory') }}</div>
				<div class="link game-close" @click="$parent.closeGame()">x</div>
			</div>	

			<div class='game-board rules' v-if="this.showStart">
					{{ model.getDictionary('game_memory_hint') }}
				<div><div class='game-btn' @click="startGame()">{{ model.getDictionary('game_start')}}</div></div>
			</div>	

			<div class='game-board memory-deck' v-if="this.showGame">

				<div v-for="card in this.deck" :key="card.id">	
					<div class='card' @click="turn(card.id)" :class="card.style">			
						<div class='img-container' v-if="card.state == 1">
							<img class='work-detail-main' 
								:src="card.work.getImages().getImageURL('small')" />
						</div>
					</div>
				</div>
			</div>	

			<div class='game-board result' v-if="this.showResult">
				<div><div class='game-btn' @click="startGame()">{{ model.getDictionary('game_play_again') }}</div></div>
			</div>	
		</div>
	</div>
</template>

<script>

	import { model } from "../model/Model.js";

	export default {

		props: [],

		data: function() { 
			return {
				// expose model for translations
				model: model,

				// Current Game State
				deck: [],
				cards: 12,

				// interaction helpers
				openIdx: -1,
				solved: 0,

				showStart: true,
				showResult: false,
				showGame: false,

				// animation helpers
				roundTimeout: null,
				roundLock: false,
				roundResult: false,
			};
		},

		methods: {
			startGame: function() {
				this.buildDeck(this.cards);
				this.openIdx = -1;
				this.solved = 0;
				this.roundLock = false;

				this.showStart = false;
				this.showResult = false;
				this.showGame = true;
			},

			/** Select the Works of art */
			buildDeck: function(cards) {

				// select the works of art
				let selection = [];
				let markAsUsed = {};
				let pool = this.model.works.getList();
				for (let i = 0; i < (cards / 2); i++) {

					// select a work of art
					let idx = Math.floor(Math.random() * pool.length);

					// make sure we don't draw the same work twice
					if (typeof markAsUsed ['I' + idx] !== 'undefined') {
						i--;
						continue;
					}

					// only select images, not audio or video
					let work = pool [idx];
					let images = work.getImages();
					if (images.hasImages() == false || images.isImage(0) == false) {
						i--;
						continue;
					}

					markAsUsed ['I' + idx] = true;
					selection.push(work);
					selection.push(work);
				}

				// shuffle
				for (let i = 0; i < 100; i++) {
					let idx1 = Math.floor(Math.random() * selection.length);
					let idx2 = Math.floor(Math.random() * selection.length);

					let tmp = selection [idx2];
					selection [idx2] = selection [idx1];
					selection [idx1] = tmp; 
				}

				// build the game board
				this.deck = [];
				for (let i = 0; i < selection.length; i++) {
					this.deck.push({
						id: i,
						work: selection [i],
						state: 0,
						style: '',
					});
				}
			},

			/** Turn a card */
			turn: function(idx) {
				if (this.roundLock || this.deck [idx].state != 0) {
					return;
				}

				// turn the card
				this.deck [idx].state = 1;

				// 
				if (this.openIdx == -1) {
					this.openIdx = idx;
				} else {
					this.checkCards(this.openIdx, idx);
				}
			},

			checkCards: function(idx1, idx2) {
				this.roundLock = true;
				let pair = (this.deck [idx1].work.getID() == this.deck [idx2].work.getID());
				this.deck [idx1].style = pair? 'correct' : 'wrong';
				this.deck [idx2].style = pair? 'correct' : 'wrong';
				let self = this;
				setTimeout(function() {self.finishRound(idx1, idx2, pair)}, pair? 1000 : 2000);
			},

			finishRound: function(idx1, idx2, pair) {
				if (pair) {
					this.deck [idx1].state = 2;
					this.deck [idx1].style = 'solved';
					this.deck [idx2].state = 2;
					this.deck [idx2].style = 'solved';
					this.solved++;
				} else {
					this.deck [idx1].state = 0;
					this.deck [idx1].style = '';
					this.deck [idx2].state = 0;
					this.deck [idx2].style = '';
				}

				this.openIdx = -1;
				if (this.solved >= this.cards / 2) {
					this.finishGame();
				} else {
					this.roundLock = false;
				}
			},

			/**  Finish the game */
			finishGame: function() {
				for (let i = 0; i < this.deck.length; i++) {
					this.deck [i].style = '';
					this.deck [i].state = 1;
				}
				this.showStart = false;
				this.showGame = true;
				this.showResult = true;
			}

		}		

	};
</script>

<style>

div.memory-deck {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 2rem;
}

div.card {
	background-color: #c6ced6;
	width: 14.5rem;
	height: 12.8rem;
	padding: 1rem;
	cursor: pointer;
}

div.solved {
	visibility: hidden;
	cursor: inherit !important;
}

div.img-container {
	width: 100%;
	height: 100%;
	object-fit: cover;
	overflow: hidden;
}

div.img-container img {
	width: 100%;
}

div.game-board {
	margin-right: 2rem;
}

div.game-bar {
	margin-top: -1rem;
	margin-bottom: 1rem;
	padding: 1rem 0;
}

div.game-bar-answer {
	padding: 1rem 2rem;
	cursor: pointer;
}

div.correct {
	background-color: #dedf6b !important;
	color: black !important;
}

div.wrong {
	background-color: #de4939 !important;
	color: white !important;
}

div.game-btn {
	background-color: #c6ced6;
	display: inline-block;
	cursor: pointer;
	padding: 1rem 2rem;
	margin: 1rem 0;
}

div.optionGrid {
	margin-top: 2rem;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: auto auto;
	row-gap: 2rem;
	column-gap: 2rem;

}

div.game-answer-btn {
	background-color: #c6ced6;
	color: black;
	cursor: pointer;
	padding: 1rem 2rem;
}

div.game-link {
	margin-top: 2rem;
}

div.result-grid {
	margin-top: 2rem;
}

div.result-entry {
	margin-bottom: 1rem;
	display: flex;
	flex-direction: row;
	align-items: center;
}

div.result-entry-image {
	height: 6rem;
	width: 10rem;
	overflow: hidden;
}
div.result-entry-image img {
	object-fit: cover;
	object-position: center center;
	width: 100%;
}

div.result-entry-label {
	margin-left: 1rem;
	height: 6rem;
	flex-grow: 1;
	padding: 2.4rem 2rem;
}

@media (min-width: 1000px) {

	div.game-close {
		display: inline;
		position: absolute;
		right: 3rem;
		top: 0rem;
	}

}

@media (max-width: 1000px) {

	div.game-close {
		position: absolute;
		top: 2.5rem;
		right: 0.5rem;
		font-size: 2rem;
	}

}
</style>